import { useCallback } from 'react';
import { useDynamicModal } from 'components/DynamicModalProvider/useDynamicModal';
import { ImpersonateAccountMenu, ImpersonateAccountMenuProps } from './ImpersonateAccountMenu';

export const useAccountImpersonationMenu = () => {
  const { openModal } = useDynamicModal();

  const openAccountImpersonationMenu = useCallback(
    (args: Omit<ImpersonateAccountMenuProps, 'onClose'>) => {
      openModal({
        modal: ({ toggle }) => <ImpersonateAccountMenu {...args} onClose={toggle} />,
      });
    },
    [openModal],
  );

  return {
    openAccountImpersonationMenu,
  };
};
